/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDentalTooth } from 'app/shared/model/dental-tooth.model';
import { IDentalSurface } from 'app/shared/model/dental-surface.model';

export interface IDentalToothSurface {
  id?: string;
  active?: boolean | null;
  cursor?: number;
  lastupdated?: number | null;
  microSec?: number | null;
  timestampentry?: number | null;
  tooth?: IDentalTooth;
  surface?: IDentalSurface;
}

export const defaultValue: Readonly<IDentalToothSurface> = {
  active: false,
};
